import { cn } from '@/lib/utils'
import React, { createContext } from 'react'

interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  disabled?: boolean
  status?: 'success' | 'error'
  statusText?: string
  large?: boolean
}

interface FieldContextType {
  disabled?: boolean
  status?: 'success' | 'error'
  statusText?: string
  fieldId?: string
  large?: boolean
}

export const FieldContext = createContext<FieldContextType | undefined>(
  undefined,
)

export default function Field({
  className,
  disabled,
  status,
  statusText,
  large,
  ...props
}: FieldProps) {
  const fieldId = React.useId()

  const fieldState: FieldContextType = {
    disabled,
    status,
    statusText,
    fieldId,
    large,
  }

  // const setDisabled = store((state) => state.setDisabled)

  // useEffect(() => {
  //   setDisabled(disabled)
  // }, [disabled, setDisabled])

  return (
    <FieldContext.Provider value={fieldState}>
      <div
        data-slot="field"
        className={cn(
          '[&>[data-slot=control]+[data-slot=description]]:mt-3 [&>[data-slot=control]+[data-slot=error]]:mt-3 [&>[data-slot=description]+[data-slot=control]]:mt-3 [&>[data-slot=label]+[data-slot=control]]:mt-1 [&>[data-slot=label]+[data-slot=description]]:mt-1 [&>[data-slot=label]]:font-medium',
          '[&:has(>[role=radio])]:flex [&:has(>[role=radio])]:items-center [&:has(>[role=radio])]:gap-1 [&>[data-slot=label]]:[&:has(>[role=radio])]:font-normal',
          className,
        )}
        {...props}
      ></div>
    </FieldContext.Provider>
  )
}
